var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8054 9.69277C21.3683 9.69277 21.014 10.0064 21.014 10.3932V18.5992H1.58273V1.40084H17.1929C17.63 1.40084 17.9843 1.08722 17.9843 0.700421C17.9843 0.313621 17.63 0 17.1929 0H0.791367C0.354342 0 0 0.313621 0 0.700421V19.2996C0 19.6864 0.354342 20 0.791367 20H21.8054C22.2423 20 22.5968 19.6864 22.5968 19.2996V10.3932C22.5968 10.0064 22.2425 9.69277 21.8054 9.69277Z",
    fill: "#604596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7681 0.459032C24.4591 0.185531 23.958 0.185531 23.6489 0.459032L10.7594 11.8673L7.557 9.03292C7.24792 8.75942 6.74689 8.75942 6.43781 9.03292C6.1288 9.30647 6.1288 9.74992 6.43781 10.0235L10.1998 13.3532C10.3544 13.4899 10.5569 13.5583 10.7594 13.5583C10.962 13.5583 11.1645 13.4899 11.319 13.3532L24.7681 1.4496C25.0772 1.17604 25.0772 0.732588 24.7681 0.459032Z",
    fill: "#604596"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareChecklist);
export default __webpack_public_path__ + "static/media/square_checklist.494f11bb30cca513a6581de9c44d9236.svg";
export { ForwardRef as ReactComponent };